<template>
<ul class="utility-actions">
    <li class="utility-actions__item">
        <modify-calendar-modal>
        <div slot-scope="{ activate }" class="">
        <button
            :aria-label="ModifyReservationPageCalendarIcon"
            class="button utility-actions__button-calendar"
            @click="activate"
            @keydown.space.prevent="activate"
            @keydown.enter.prevent="activate"
        >
        </button>
        </div>
        </modify-calendar-modal>
    </li>
    <!-- <li class="utility-actions__item">
        <button :aria-label="ModifyReservationPageEmailIcon"  class="button utility-actions__button-email"></button>
    </li> -->
    <!--leaving commented for now-->
    <li class="utility-actions__item">
        <button :aria-label="ModifyReservationPagePrintIcon" @click.prevent="print" class="button utility-actions__button-print"></button>
    </li>
</ul>
</template>

<script>
  import { mapState } from 'vuex'
  import modifyCalendarModal from "../modals/modify-calendar-modal.vue" 

    export default {
        name: 'utility-actions',
        components: {
        modifyCalendarModal
        },
        computed: {
            ...mapState('modifyReservation', ['currentReservationData','modifyBookingPropData']),
            ModifyReservationPageCalendarIcon() {
                return this.modifyBookingPropData?.ModifyReservationPageCalendarIcon ? this.modifyBookingPropData?.ModifyReservationPageCalendarIcon : 'Calendar'
            },
            ModifyReservationPageEmailIcon() {
                return this.modifyBookingPropData?.ModifyReservationPageEmailIcon ? this.modifyBookingPropData?.ModifyReservationPageEmailIcon : 'Email'
            },
            ModifyReservationPagePrintIcon() {
                return this.modifyBookingPropData?.ModifyReservationPagePrintIcon ? this.modifyBookingPropData?.ModifyReservationPagePrintIcon : 'Print'
            },
        },
        methods: {
            print() {
                window.print();
            }
        }
    }
</script>
  